import { visitableType } from '~/assets/js/utils/visitable-type'

const concatPathname = (base, path) => {
  const regexOptionalLeadingSlash = /^\/?/

  return base + path.replace(regexOptionalLeadingSlash, '')
}

export default function ({ app, $gtm }, _inject) {
  if (process.server) return

  const pushTrackingEvent = (route) => {
    const { query, path } = route

    const { base } = app.router.options

    const manualVisitablePath = concatPathname(base, path)

    const manualVisitableType = visitableType(path)

    const userAgent = navigator?.userAgent ?? ''

    $gtm.push({
      event: 'gambit.manual_do_enem.tracking',
      gclid: query.gclid ?? '',
      ip: '',
      lat: '',
      lng: '',
      noBaseUserIdRequired: true,
      noVisitableIdRequired: true,
      partner_id: '',
      referrer: manualVisitablePath,
      user_agent: userAgent,
      utm_campaign: query.utm_campaign ?? '',
      utm_content: query.utm_content ?? '',
      utm_medium: query.utm_medium ?? '',
      utm_source: query.utm_source ?? '',
      utm_term: query.utm_term ?? '',
      visitable_path_manual: manualVisitablePath,
      visitableType: manualVisitableType,
      zanpid: query.zanpid ?? '',
    })
  }

  app.router.afterEach((route) => {
    pushTrackingEvent(route)
  })
}
